"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var request_1 = __importDefault(require("./request"));
var Uploader = /** @class */ (function (_super) {
    __extends(Uploader, _super);
    function Uploader() {
        var _this = _super.call(this) || this;
        _this.state = {};
        return _this;
    }
    Uploader.prototype.componentWillUnmount = function () {
        //abort a request if the component is unmounted mid request
        if (this.xhr && this.xhr.readyState && this.xhr.readyState !== 0 && this.xhr.readyState !== 4)
            this.xhr.abort();
    };
    Uploader.prototype.handleFiles = function (files) {
        this.setState({ files: files });
        if (this.props.uploadOnSelection)
            this.handleUpload(files);
    };
    Uploader.prototype.handleUpload = function (files) {
        var _this = this;
        if (files === void 0) { files = this.state.files; }
        var progress = this.state.progress;
        var _a = this.props, request = _a.request, onComplete = _a.onComplete, onError = _a.onError, onStart = _a.onStart, onAbort = _a.onAbort, reset = _a.reset;
        if (!files || !files.length)
            return;
        if (onStart) {
            onStart(files);
        }
        if (progress) {
            this.setState({
                progress: 0.1,
                error: false,
                aborted: false,
                complete: false,
            });
        }
        request_1.default({
            request: request,
            files: files,
            instance: function (xhr) { return (_this.xhr = xhr); },
            progress: function (value) { return _this.setState({ progress: value || 0.1 }); },
            overwriteId: this.props.overwriteId,
        }).then(function (_a) {
            var response = _a.response, error = _a.error, aborted = _a.aborted, status = _a.status;
            if (error) {
                if (onError) {
                    onError(error);
                }
                return _this.setState({ error: error, response: response, status: status });
            }
            if (aborted) {
                if (onAbort) {
                    onAbort(aborted);
                }
                return _this.setState({ aborted: aborted });
            }
            if (onComplete)
                onComplete({ response: response, status: status });
            if (reset)
                return _this.setState({
                    response: null,
                    status: null,
                    error: null,
                    aborted: null,
                    complete: false,
                    progress: 0,
                });
            _this.setState({ response: response, status: status, complete: true });
        });
    };
    Uploader.prototype.render = function () {
        var _this = this;
        var children = this.props.children;
        return children(__assign({}, this.state, { onFiles: function (files) { return _this.handleFiles(files); }, startUpload: function () { return _this.handleUpload(); } }));
    };
    return Uploader;
}(react_1.default.Component));
exports.default = Uploader;
//# sourceMappingURL=uploader.js.map


//////////////////
// WEBPACK FOOTER
// .-core/es/libs/navjobs-upload/uploader.js
// module id = 2558
// module chunks = 0